import Button from 'antd/lib/button'
import Image from 'antd/lib/image'
import { useTranslation } from 'translations'
import SwapBox from './SwapBox'
import { useNavigate } from 'react-router-dom'
import RouteList from 'pages/Routes'

const Banner = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()

	return (
		<div className="flex flex-col justify-center gap-4 pt-6 pb-10">
			<h1 className="text-primary font-extrabold text-3xl">
				{t("Send, Receive. Anytime, Anywhere.")}
			</h1>

			<p className="text-[#858792] text-base">
				{t("Now it’s effortless to do more with your assets. Instantly convert crypto to fiat, or fiat to fiat—all in just a few taps.")}
			</p>

			<Button type="primary" className='py-5 max-w-[200px]' onClick={() => navigate(RouteList.send)}>
				{t("Let's get started!")}
			</Button>

			<p className="font-bold">{t("or download")}</p>

			<AppDownload />
			<SwapBox />
		</div>
	)
}

export default Banner

export const AppDownload = () => (
	<div className="flex items-center gap-4">
		<Image preview={false} src='/images/logo/ios-download.png' className='max-w-[120px]' />
		<Image preview={false} src='/images/logo/android-download.png' className='max-w-[120px]' />
	</div>
)